import { FC, useRef } from 'react';
import { useLogging } from '../hooks/common/useLogging';
import { useEmitResetWindow } from '../hooks/common/useEmitResetWindow';

import { SUBSCRIPTION_NAME } from '../constants';
import { SectionTitle } from '../components/common/SectionTitle';
import { HorizontalRule } from '../components/common/HorizontalRule';
import { NavigationWrapper } from '../components/common/NavigationWrapper';
import { Button } from '../components/common/Button';
import { Description } from '../components/common/Description';

export const SubscriptionCancelComplete: FC = () => {

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(rootElementReference, []);

  useLogging('SubscriptionCancelComplete');

  return (
    <div 
      className={`appContainer subscriptionCancelComplete`}
      ref={rootElementReference}
    >
      <SectionTitle>{SUBSCRIPTION_NAME}の解約が完了しました。</SectionTitle>
      <Description>
        今までご利用をいただきまして誠にありがとうございました。<br/>
        解約を確かに承りました。
      </Description>
      <HorizontalRule/>
      <NavigationWrapper>
        <Button type="secondary" externalLink={`${document.referrer.replace(/\/$/, '')}/account`}>もどる</Button>
      </NavigationWrapper>
    </div>
  );
}